import { render, staticRenderFns } from "./jiagou.vue?vue&type=template&id=7e529675"
import script from "./jiagou.vue?vue&type=script&lang=js"
export * from "./jiagou.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./jiagou.vue?vue&type=custom&index=0&blockType=style-scope&lang=scss"
if (typeof block0 === 'function') block0(component)

export default component.exports